import React from 'react'

const TOT = () => {
  return (
    <div>
          <h2> Tales of Transformation </h2>
          <h3>Architect Your Next</h3>
          <h3>Three Featured Stories of Tales of Transformation</h3>
          <h3>List Tales of Transformation across industries</h3>
		</div>
  )
}

export default TOT